const dateTimeFormatter = new Intl.DateTimeFormat('es', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

const dateFormatter = new Intl.DateTimeFormat('es', { dateStyle: 'medium' });

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : dateTimeFormatter.format(date);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : dateFormatter.format(date);
}

/** Tiempo relativo corto para listas ("hace 5 min"). */
export function formatRelative(value: string | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  const diffSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  const absolute = Math.abs(diffSeconds);

  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ['second', 60],
    ['minute', 3600],
    ['hour', 86_400],
    ['day', 604_800],
    ['week', 2_629_800],
    ['month', 31_557_600],
  ];

  const formatter = new Intl.RelativeTimeFormat('es', { numeric: 'auto' });

  if (absolute < 60) return formatter.format(diffSeconds, 'second');
  for (let index = 1; index < units.length; index += 1) {
    const [unit, limit] = units[index];
    if (absolute < limit) {
      const divisor = units[index - 1][1];
      return formatter.format(Math.round(diffSeconds / divisor), unit);
    }
  }
  return formatter.format(Math.round(diffSeconds / 31_557_600), 'year');
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
